import {jsonArrayMember, jsonMember, jsonObject} from "typedjson";
import {DxGridPage} from "../../dx-grid/domain/dx-grid-page";
import {DxGridRow} from "../../dx-grid/domain/dx-grid-row";


@jsonObject
export class PitGridPage implements DxGridPage {
  @jsonMember({name: "pageIndex", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _pageIndex: number;

  @jsonMember({name: "pageSize", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _pageSize: number;

  @jsonMember({name: "totalRowsCount", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _totalRowsCount: number;

  @jsonMember({name: "totalPagesCount", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _totalPagesCount: number = 0;

  /**
   * Поле дублирующее totalRowsCount в некоторых случаях
   */
  @jsonMember({constructor: Number, emitDefaultValue: false, isRequired: false })
  totalCount: number = 0;

  pageData: DxGridRow[];

  public getPageIndex(): number {
    return this._pageIndex;
  }

  public setPageIndex(value: number): void {
    this._pageIndex = value;
  }

  public getPageSize(): number {
    return this._pageSize;
  }

  public setPageSize(value: number): void {
    this._pageSize = value;
  }

  public getTotalRowsCount(): number {
    return this._totalRowsCount || this.totalCount;
  }

  public getTotalPagesCount(): number {
    return this._totalPagesCount;
  }

  public getPageData(): DxGridRow[] {
    return this.pageData;
  }

  get pageIndex(): number {
    return this._pageIndex;
  }

  set pageIndex(value: number) {
    this._pageIndex = value;
  }

  get pageSize(): number {
    return this._pageSize;
  }

  set pageSize(value: number) {
    this._pageSize = value;
  }

  get totalRowsCount(): number {
    return this.totalCount || this._totalRowsCount;
  }

  set totalRowsCount(value: number) {
    this._totalRowsCount = value;
  }

  get totalPagesCount(): number {
    return this._totalPagesCount;
  }

  set totalPagesCount(value: number) {
    this._totalPagesCount = value;
  }

}
